export const filterValue = (form) => {
  const formValue = form?.value;
  const filterFormValue = formValue !== null ? [formValue] : [];

  return filterFormValue;
};

export const filterMultiValue = (form) => {
  const filterFormValue = form[0].value !== null ? form?.map((row) => row.value) : [];

  return filterFormValue;
};

export const filterDepartmentOptions = (data) => {
  const dropdownValue = data
    ?.filter((row) => row.name !== null)
    .map((row) => ({
      value: row.name,
      label: row.name,
    }));

  return dropdownValue;
};

export const filterTeamV4Options = (data) => {
  const dropdownValue = data
    ?.filter((row) => row.rep_team !== null && row.rep_team !== 'GAS')
    .map((row) => ({
      value: row.rep_team,
      label: row.rep_team,
    }));

  return dropdownValue;
};

export const filterTeamOptions = (data) => {
  const dropdownValue = data
    ?.filter((row) => row.team !== null && row.team !== 'GAS')
    ?.map((row) => ({
      value: row?.team,
      label: row?.team,
    }));

  return dropdownValue;
};

export const filterHeadOptions = (data) => {
  const dropdownValue = data?.map((row) => ({
    value: row.head_id,
    label: row.head_name,
  }));

  return dropdownValue;
};

export const filterManagerOptions = (data) => {
  const dropdownValue = data?.map((row) => ({
    value: row.manager_id,
    label: row.manager_name,
  }));

  return dropdownValue;
};

export const filterRepOptions = (data) => {
  const dropdownValue = data
    ?.filter((row) => row.rep_id !== 'VACANT')
    ?.map((row) => ({
      value: row.rep_id,
      label: row.rep_name,
    }));

  return dropdownValue;
};

export const filterDoctorOptions = (data) => {
  const dropdownValue = data?.map((row) => ({
    value: row?.doctor_id,
    label: row?.doctor_name ?? 'No MD Name',
  }));

  return dropdownValue;
};

export const filterDoctorv2Options = (data) => {
  const dropdownValue = data?.map((row) => ({
    value: row?.md_id,
    label: row?.md_name ?? 'No MD Name',
  }));

  return dropdownValue;
};

export const filterGroupOptions = (data) => {
  const dropdownValue = data
    ?.filter((row) => row.md_group !== null)
    .map((row) => ({
      value: row.md_group,
      label: row.md_group,
    }));
  return dropdownValue;
};

export const filterSpecialtyOptions = (data) => {
  const dropdownValue = data
    ?.filter((row) => row.specialty !== '' && row.specialty !== null)
    .map((row) => ({
      value: row.specialty,
      label: row.specialty,
    }));

  return dropdownValue;
};
